import { Component, DestroyRef, inject, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import {  MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BaseComponent } from 'src/app/base/base.component';
import { ColoredTextItem, NamedColorList } from 'src/app/domainObjects/coloredTextItem';
import { NamedColor } from 'src/app/domainObjects/namedColor';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { JsonPasteDialogComponent } from '../json-paste-dialog/json-paste-dialog.component';
import { FileUploadDialogComponent } from '../file-upload-dialog/file-upload-dialog.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { KeyboardService } from 'src/app/services/keyboard/keyboard.service';

class ViewModel {
  colors: NamedColor[];
  textItems: ColoredTextItem[] = [];
  currentColor: NamedColor;
  currentName: string;

  constructor(items: ColoredTextItem[]) {

    const itemsCopy = items.map(r => new ColoredTextItem(r.text, r.color)) ?? [];

    this.textItems = itemsCopy ?? [];
    this.colors = NamedColorList;

    // const maxIndex = this.colors.length - 1;
    // let nextIndex = this.textItems.length;
    // if (nextIndex > maxIndex) {
    //   nextIndex = (nextIndex%maxIndex)+1;
    // }
    const maxlength = this.colors.length;
    let nextlength = this.textItems.length+1;
    var nextIndex=nextlength-1;
    if (nextlength > maxlength) {
      var rem = (nextlength%maxlength);
      if(rem==0){
        nextIndex=maxlength-1;
      }
      else{
        nextIndex=rem-1;
      }
    }
    this.currentColor = this.colors[nextIndex];
  }
}

@Component({
    selector: 'app-contains-text-dialog-option',
    templateUrl: './contains-text-dialog-option.component.html',
    styleUrls: ['./contains-text-dialog-option.component.css'],
    standalone: false
})
export class ContainsTextDialogOptionComponent extends BaseComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  title: string;
  label: string;
  placeholder: string;
  fieldType: string="edit";// Possible values: 'edit', 'dropdown', 'autocomplete'. Default 'edit'
  isDuplicateRemoved: boolean=false;//Remove Duplicate field value. Default false
  canAddNewAutocomplete: boolean=false;//Can add new item in Autocomplete
  options: string[]=[];//Option values for 'dropdown'and 'autocomplete'. Default []
  optionsDropdown: string[]=[];//Option values for 'dropdown' list with default starting option[] as remove duplicate mean it nor show in the dropdown. Default []
  myControl = new FormControl();
  filteredOptions!: Observable<string[]>;
  enterKeyPressCount: number = 0;  // Counter for Enter key presses
  disableAllNone: boolean=false;
  disableAllNoneMsg:string="";
  optionsRaw: string[]=[];//Option values for back up when remove duplicate retrieve
  showRefresh: boolean =false;
  refreshTooltip: string = 'Refresh';

  viewModel: ViewModel;
  @ViewChild('textbox') textbox: ElementRef;
  @ViewChild('textboxmatform', { read: ElementRef }) textboxmatform: ElementRef;
  @ViewChild('fakeclick') fakeclick!: ElementRef<HTMLInputElement>;
  @ViewChild(MatDialogRef, { read: ElementRef })dialogContainer!: ElementRef<HTMLElement>;
  @ViewChild('keyboardContainer', { static: true }) keyboardContainer!: ElementRef<HTMLElement>;
  @ViewChild('dialogRoot', { static: true }) dialogRoot!: ElementRef;
  onClosed?: (items: ColoredTextItem[], eventname: string) => any;

  constructor(
    private dialogRef: MatDialogRef<ContainsTextDialogOptionComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData,
     private keyboardService: KeyboardService,
    errorLogger: ErrorReportingService,
    matDialog: MatDialog,private snackBar: MatSnackBar) {

      super(errorLogger, matDialog);
  }
  
  // @HostListener('document:keydown.escape')
  // onEscapePress() {
  //   this.cancel();
  // }

  async ngOnInit(): Promise<void> {
    this.onClosed = this.dialogData?.onClosed;
    this.title = this.dialogData.title;
    this.label = this.dialogData.label;
    this.placeholder = this.dialogData.placeholder;
    this.viewModel = new ViewModel(this.dialogData.items);
    this.fieldType = this.dialogData.fieldType;
    this.isDuplicateRemoved=this.dialogData.isDuplicateRemoved;
    this.canAddNewAutocomplete=this.dialogData.canAddNewAutocomplete;
    this.options = this.dialogData.options;
    this.showRefresh = this.dialogData?.showRefresh ?? true;
    this.refreshTooltip = this.dialogData?.refreshTooltip ?? 'Refresh';
    // Remove undefined values else it gives error
    this.options = this.options.filter((opt): opt is string => opt !== undefined);
    this.optionsDropdown=[...this.options];
    this.optionsRaw=[...this.options];
    this.viewModel.currentName="";
    
    await this.allNoneCondition();
    // Set up the filtering logic
    if(this.fieldType=="autocomplete"){
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value || ''))
      );
    }
    if(this.fieldType=="autocomplete" || this.fieldType=="dropdown"){
      if(this.isDuplicateRemoved){
        this.removeOptionDuplicate();
      }
    }
  }
  ngAfterViewInit(): void {
    // Focus out from the textbox after view initialization
    if(this.fieldType!="dropdown"){
      this.textbox.nativeElement.blur();
    }
    this.keyboardService.onKey('Escape', () => {
    this.cancel();
  }, this.destroyRef);
  this.keyboardService.registerEnterToDelete(
    () => this.viewModel.textItems,
    (item) => this.deleteItem(item),
    '#add-input', // 🔥 fallback focus
    this.destroyRef
  );
  //   this.keyboardService.registerArrowNavigation(
  //   this.dialogRoot.nativeElement
  // );
  this.keyboardService.registerGlobalDoubleEnter(() => {
  this.save();
}, this.destroyRef);
  
  }
  // Filter method for autocomplete
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }
  save(): void {
    var isvalid=true;
    this.viewModel.textItems.forEach(item=>{
      if(item.text==null || item.text=="" || item.text.trim().length==0){
        isvalid=false;
        return;
      }
    })
    if(!isvalid){
      this.displayWarning("No entries can be empty, please enter values or remove the row(s).","Warning.");
      return;
    }
    this.dialogRef.close({items: this.viewModel.textItems,eventname:'save'});
    // this.keyboardService.focusInput(this.textboxFocus?.nativeElement, 150);
  }

  cancel(): void {
    this.dialogRef.close({items: this.viewModel.textItems,eventname:'cancel'});
  }

  deleteItem(item: ColoredTextItem): void {
    const index = this.viewModel.textItems.indexOf(item);
    this.viewModel.textItems.splice(index, 1);
    //this.textbox.nativeElement.focus();
    if(this.fieldType=="autocomplete"){
      if(this.isDuplicateRemoved){
        this.options=[...this.optionsRaw];
        this.removeOptionDuplicate();
      }
    }
    this.reassignColors();
    this.allNoneCondition();
  }
  addItem(): void {
    this.enterKeyPressCount = 0;
    const item = new ColoredTextItem(this.viewModel.currentName, this.viewModel.currentColor);
    this.viewModel.textItems.push(item);

    const maxlength = this.viewModel.colors.length;
    let nextlength = this.viewModel.textItems.length+1;
    var nextIndex=nextlength-1;
    if (nextlength > maxlength) {
      var rem = (nextlength%maxlength);
      if(rem==0){
        nextIndex=maxlength-1;
      }
      else{
        nextIndex=rem-1;
      }
    }
    this.viewModel.currentColor = this.viewModel.colors[nextIndex];
    this.viewModel.currentName="";
    if(this.fieldType!="dropdown"){
      this.textbox.nativeElement.focus();
    }
    this.textboxmatform.nativeElement.classList.remove('mat-form-field-invalid');
    if(this.fieldType=="autocomplete" || this.fieldType=="dropdown"){
      if(this.isDuplicateRemoved){
        this.removeOptionDuplicate();
      }
    }
    this.allNoneCondition();
  }
  removeOptionDuplicate(): void {
    var removeList=this.viewModel.textItems.map(item => item.text);
    this.options=this.options.filter(option => !removeList.includes(option));
  }

  private previousValues: string;
  // Store previous value before selection changes
  storePreviousValue(item: string) {
    this.previousValues=item; 
  }
  onCheckDuplicate(event: any, item: ColoredTextItem) {
    setTimeout(() => {
      const previousValue = this.previousValues;
      const selectedValue = event.value;
      // Check for duplicates (excluding the current item)
      const isDuplicate = this.viewModel.textItems.some(
        (existingItem) => existingItem !== item && existingItem.text === selectedValue
      );

      if (isDuplicate) {
        setTimeout(() => {
          item.text = previousValue; // Revert to previous value
          this.previousValues=""
        }, 0);
        this.displayWarning("Duplicate value selected! Reverting to previous value.","Duplicate")
      } else {
        this.previousValues=""
        // Update stored value
        this.options=[...this.optionsDropdown];
        this.removeOptionDuplicate();
      }
    }, 100);
  }
  reassignColors(): void {
    try{
      this.viewModel.textItems.forEach((item, i) => {
        item.color = NamedColorList[i % NamedColorList.length];
      });
      const nextIndex = this.viewModel.textItems.length;
      this.viewModel.currentColor = NamedColorList[nextIndex % NamedColorList.length];
    }catch (err) {
      console.log('Failed to reassignColors', err);
    }
  }
  
  async validateSelection(): Promise<void> {
    if(this.viewModel.currentName==null || this.viewModel.currentName=="" || this.viewModel.currentName.trim().length==0){
      this.viewModel.currentName="";
      this.textboxmatform.nativeElement.classList.add('mat-form-field-invalid');
      this.enterKeyPressCount++;  // Increment Enter key press counter
      if (this.enterKeyPressCount >= 2) {
        this.save();
      }
      return;
    }

    if(this.fieldType === 'autocomplete'){
      if(this.canAddNewAutocomplete){
        this.addItem();
      }else{
        if (!this.options.includes(this.viewModel.currentName)) {
          this.myControl.setValue(''); // Clear the input if the value is invalid
          return;
        }else{
          this.addItem();
        }
      }
    }else if(this.fieldType === 'dropdown'){
      setTimeout(() => {this.addItem()}, 500);
    }else if(this.fieldType === 'edit'){
      this.addItem();
    }
  }

  onKeyEnter(event: Event) {
    const currentValue = this.myControl.value;
    if(currentValue===""){
      event.preventDefault();
      this.textbox.nativeElement.blur();
      this.fakeclick.nativeElement.click();//for legacy issue if remove legacy this.autocompleteTrigger.closePanel(); 
      this.addItem();
    }else{
      if (!this.options.includes(currentValue)) {
        this.myControl.setValue(''); // Clear the input if the value is invalid
      }else{
        event.preventDefault();
        this.textbox.nativeElement.blur();
        this.fakeclick.nativeElement.click();
      }
    }
  }

  previousValue: string = '';
  savePreviousValue(text:string) {
    this.previousValue = text;
  }

  async checkValue(item: ColoredTextItem) {
    if(!this.canAddNewAutocomplete){
      const currentValue = item.text;
      if (!this.options.includes(currentValue)) {
        item.text = this.previousValue; // Restore previous valid value
      }
    }
  }
  async allNoneCondition():Promise<void>{
    const allNoneItem = this.viewModel.textItems.find(
      itm => itm.text === "All" || itm.text === "None"
    );
    if(allNoneItem){
      this.viewModel.textItems = [allNoneItem];
      this.disableAllNone=true;
      this.myControl.disable();
      if(allNoneItem.text === "All"){
        this.disableAllNoneMsg=" Remove 'All' to select fields."
      }else if(allNoneItem.text === "None"){
        this.disableAllNoneMsg=" Remove 'None' to select fields."
      }
    }else{
      this.disableAllNone=false;
      this.myControl.enable();
      this.disableAllNoneMsg="";
    }
  }
  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.viewModel.textItems, event.previousIndex, event.currentIndex);
    this.reassignColors(); // if order affects color
  }
  async import(): Promise<void>{
    const dialogRef = this.matDialog.open(FileUploadDialogComponent, {
      width: '600px',
      height: '470px',
      panelClass: 'import-dialog-fix',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        for (const item of result) {
          this.viewModel.currentName = item.find;        // or push into an array
          await this.addItem();
          this.viewModel.currentName = "";
        }
      }
    });
  }
  async Export(): Promise<void>{
    const lines = this.viewModel.textItems.map(item =>item.text); 
    const content = lines.join("\n");

    const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = "exported_items.txt";
    a.click();
    URL.revokeObjectURL(url);
  }
  async CopyJSON(): Promise<void>{
    try {
      const json = JSON.stringify(this.viewModel.textItems?.map(i => i.text));
      await navigator.clipboard.writeText(json);
      this.snackBar.open("JSON Copied to Clipboard", 'Dismiss', {
          duration: 5000,
        });
    } catch (err) {
      this.displayError("Failed to copy JSON", "Error");
    }
  }
  async CopyText(): Promise<void>{
    try {
      const items = this.viewModel.textItems?.map(i => i.text) ?? [];
      const plainText = items.join('\n');

      await navigator.clipboard.writeText(plainText);
      this.snackBar.open("Text Copied to Clipboard", 'Dismiss', {
          duration: 5000,
        });
    } catch (err) {
      this.displayError("Failed to copy text", "Error");
    }
  }
  async PasteJSON(): Promise<void>{
    const dialogRef = this.matDialog.open(JsonPasteDialogComponent, {
      width: '600px',
      height: '420px',
      disableClose: true,
      data: { inputType: 'json' }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (!result) return;

      let items: string[] = [];

      // If result is already an array (JSON case)
      if (Array.isArray(result)) {
        items = result;
      }

      // Now loop and add items
      for (const item of items) {
        this.viewModel.currentName = item;
        await this.addItem();
        this.viewModel.currentName = "";
      }
    });
  }
  async PasteText(): Promise<void>{
    const dialogRef = this.matDialog.open(JsonPasteDialogComponent, {
      width: '600px',
      height: '420px',
      disableClose: true,
      data: { inputType: 'text' }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (!result) return;

      let items: string[] = [];

      if (typeof result === 'string') {
        // TEXT CASE: split by comma, newline, semicolon, or multiple spaces
        items = result
          .split(/[\n,;]+/) // split on new line, comma, semicolon
          .map(x => x.trim())
          .filter(x => x.length > 0);
      }

      // Now loop and add items
      for (const item of items) {
        this.viewModel.currentName = item;
        await this.addItem();
        this.viewModel.currentName = "";
      }
    });
  }
  async DeleteAll(): Promise<void>{
    this.viewModel.textItems=[];
    this.reassignColors();
  }

  async onOptionSelected(event: any) {
    const selectedValue = event.option.value;
    this.viewModel.currentName = selectedValue;       // Set selected
    await this.validateSelection();   
    setTimeout(() => {
      this.myControl.reset();
      this.viewModel.currentName = "";
      this.enterKeyPressCount=0;
    });
  }

  onSelectDropDown(event: any) {
    const selectedValue = event.value;
    this.viewModel.currentName = selectedValue;
    // Auto-validate after selecting
    this.validateSelection();
  }
onInputKeydown(event: KeyboardEvent): void {
  if (
    event.key === 'ArrowUp' ||
    event.key === 'ArrowDown' ||
    event.key === 'ArrowLeft' ||
    event.key === 'ArrowRight'
  ) {
    event.stopPropagation();
  }
}

  async refresh(): Promise<void>{
    if (this.onClosed) {
      await this.onClosed(this.viewModel.textItems, 'refresh');
    }
  }
}
